import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Brain, Lock, ArrowRight, Award, Target, Sparkles } from 'lucide-react';
export const AIEntrepreneurshipHighlightSection = () => {
  const pillars = [{
    icon: Lock,
    title: 'Application Only',
    body: 'Selective. Admission by application, reviewed for fit and potential.'
  }, {
    icon: Award,
    title: 'Limited Cohort',
    body: 'A small group of ambitious students is selected each season.'
  }, {
    icon: Target,
    title: 'Real Work',
    body: 'Live project contribution across AI, entrepreneurship, and product building.'
  }];
  return <section id="ai-entrepreneurship-highlight" className="py-20 md:py-28 bg-black relative overflow-hidden border-t border-amber-400/10" data-id="element-133" data-mp="30ay4ix9t58bi">
      <div className="absolute inset-0" data-id="element-134" data-mp="o80anedy3ni">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black" data-id="element-135" data-mp="3s12lelyczd7z" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_rgba(212,175,55,0.08),_transparent_70%)] pointer-events-none" data-id="element-136" data-mp="2qr3er6t92f65" />
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-137" data-mp="2vp4txgnk1ucc">
        <div className="max-w-6xl mx-auto" data-id="element-138" data-mp="2h1s4hgumn4go">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center mb-12 max-w-3xl mx-auto" data-id="element-139" data-mp="2gyxmdvz35vqf">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-amber-400 mb-6 bg-amber-400/10 shadow-[0_0_25px_rgba(212,175,55,0.15)]" data-id="element-140" data-mp="1y48w8ffztpvb">
              <Lock className="w-3.5 h-3.5 text-amber-400" data-id="element-141" data-mp="3sh8i2qayvgb1" />
              <span className="text-amber-400 tracking-[0.3em] text-[10px] uppercase font-bold" data-id="element-142" data-mp="19vuntjhq6mo">
                Application Only · Limited Cohort
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-white mb-5 leading-[1.05] tracking-tight" data-id="element-143" data-mp="3vvqgitgc0oi1">
              Entrepreneurship and AI{' '}
              <span className="text-amber-400" data-id="element-144" data-mp="3m0orrypyxofz">Opportunity</span>
            </h2>
            <p className="font-serif italic text-amber-400/90 text-lg sm:text-xl mb-5" data-id="element-145" data-mp="3hz3ewddfpa5s">
              Canada&rsquo;s Premier Entrepreneurship and AI Discovery
              Opportunity
            </p>
            <div className="w-20 h-px bg-amber-400/40 mx-auto mb-7" data-id="element-146" data-mp="dl51n8klgm55" />
            <p className="text-white/65 text-base sm:text-lg font-light leading-relaxed" data-id="element-147" data-mp="8t56dtfgyhew">
              A selective, application-only summer opportunity for ambitious
              students. Limited cohort. Real work. Serious exposure.{' '}
              <span className="text-amber-400" data-id="element-148" data-mp="11ahj0vq2s0ij">Earn your place.</span>
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12" data-id="element-149" data-mp="whepgnlasr2c">
            {pillars.map((p, i) => <motion.div key={p.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="relative border border-amber-400/20 hover:border-amber-400/50 transition-colors p-6 bg-gradient-to-b from-amber-950/10 to-transparent" data-id="element-150" data-mp="2f7k6r9lvgek6" data-mpi={i}>
                <span className="absolute -top-px left-4 right-4 h-px bg-gradient-to-r from-transparent via-amber-400/60 to-transparent" data-id="element-151" data-mp="3bvqjkjsy6d9j" />
                <div className="w-9 h-9 border border-amber-400/40 bg-black/40 flex items-center justify-center mb-4" data-id="element-152" data-mp="3gwe7uxpskg02">
                  <p.icon className="w-4 h-4 text-amber-400" data-id="element-153" data-mp="3lufrbjr4qhc2" />
                </div>
                <h3 className="font-serif text-lg text-white mb-2 leading-tight" data-id="element-154" data-mp="3864i70b2kx4r">
                  {p.title}
                </h3>
                <p className="text-white/55 text-sm font-light leading-relaxed" data-id="element-155" data-mp="3369qiujh03in">
                  {p.body}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative border border-amber-400/30 bg-gradient-to-br from-amber-950/15 via-black/40 to-black p-6 sm:p-8 flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-10" data-id="element-156" data-mp="3cyxnbpaga7hd">
            <span className="absolute -top-px left-8 right-8 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent" data-id="element-157" data-mp="9hp6n8rgldo8" />
            <div className="flex-1" data-id="element-158" data-mp="h06mdwpxhopn">
              <div className="flex items-center gap-2 mb-2.5" data-id="element-159" data-mp="h3143ghk4vfd">
                <Brain className="w-4 h-4 text-amber-400" data-id="element-160" data-mp="m0u9w8ey7nf4" />
                <span className="text-amber-400 tracking-[0.3em] text-[10px] uppercase font-bold" data-id="element-161" data-mp="80jkl9taegw2">
                  Applications Open
                </span>
              </div>
              <p className="font-serif text-xl sm:text-2xl text-white leading-snug max-w-2xl" data-id="element-162" data-mp="c3okr5pwa6hj">
                Selective cohort across AI, entrepreneurship, digital media,
                immersive experiences, and product building.
              </p>
              <p className="text-white/40 text-xs mt-3 font-light tracking-wide" data-id="element-163" data-mp="qy2xioiv8jnr">
                Optional 15 Laws of Growth track available · Not required for
                selection
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0" data-id="element-164" data-mp="1ioqxvycptl0d">
              <Link to="/ai-entrepreneurship" className="group inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-amber-400 text-black text-[11px] tracking-[0.3em] uppercase font-bold hover:bg-amber-300 transition-colors shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-165" data-mp="1ni2540lfw3st">
                <Sparkles className="w-3.5 h-3.5" data-id="element-166" data-mp="1oardiouw73ly" />
                Explore the Opportunity
                <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" data-id="element-167" data-mp="1jcg5mjo5r36d" />
              </Link>
              <Link to="/ai-entrepreneurship#apply" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-amber-400/40 hover:border-amber-400 text-amber-400 text-[11px] tracking-[0.3em] uppercase font-semibold hover:bg-amber-400/5 transition-colors" data-id="element-168" data-mp="1efg0qc31o6gu">
                Apply Now
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};